import { FC } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { cn, FaIcon } from '@fe-learner-common';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';

type ChipProps = {
  className?: string;
  icon?: IconDefinition;
  label: string;
  onRemove?: () => void;
};

export const Chip: FC<ChipProps> = ({
  className,
  icon,
  label,
  onRemove,
  ...rest
}) => {
  return (
    <button
      className={cn(
        'text-netral-900 flex items-center gap-1.5 rounded-full bg-neutral-100 px-3 py-2 text-label-md hover:bg-neutral-200',
        className,
      )}
      onClick={onRemove}
      {...rest}
    >
      {icon && <FaIcon icon={icon} width={16} height={16} />}
      <span>{label}</span>
      {onRemove && <FaIcon icon={faXmark} width={16} height={16} />}
    </button>
  );
};
